module.exports = __webpack_public_path__ + "media/images/serie_a-3b111a09a2898eb48b663935ec296988.png";